/* Skullette ODD LOT SALE (one-day sale, Thu 2026-10-15 → 23:59:59 ET) — shared core, loaded first (defer). Exposes
 * window.SOL for the lightning / shelf / quick-view / sticky-bar modules. Product data is rendered inline by Liquid
 * (snippet skullette-odd-lot-sale-product-data-json) with LIVE stock: { h, t, v, p, c, a, q, s, g, k, tg, i }
 * (handle, title, variant id, price¢, compare¢, available, qty (odd-lot only), source odd|slow, group, kind, top-grain, image).
 * Every 150 s the section is re-rendered via the Section Rendering API to refresh stock → 'sol:data' event.
 * Clock: ?olnow=2026-10-15T14:30 (ET) shifts "now" for QA. Port of afroyla-last-pieces-core.js (frozen). */
(function () {
  var root = document.querySelector('[data-sol]');
  if (!root) return;
  var END = Date.parse(root.dataset.end || '2026-10-15T23:59:59-04:00');
  var offset = 0;
  var q = new URLSearchParams(location.search).get('olnow');
  if (q) { var t = Date.parse(q + (/[zZ]|[+-]\d\d:?\d\d$/.test(q) ? '' : '-04:00')); if (!isNaN(t)) offset = t - Date.now(); }
  function now() { return Date.now() + offset; }
  function phase() { return now() > END ? 'ended' : 'live'; }

  function money(n) { return '$' + Number(n).toFixed(2); }
  function pct(price, compare) { return compare > price ? Math.round(100 - (100 * price) / compare) : 0; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function mss(ms) { var s = Math.max(0, Math.ceil(ms / 1000)); return Math.floor(s / 60) + ':' + pad(s % 60); }
  function hms(ms) { var s = Math.max(0, Math.floor(ms / 1000)); return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60); }
  function img(src, w) { if (!src) return ''; src = src.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cleanTitle(t) { return String(t).replace(/\s*[-—]?\s*(ODD\s*LOT|STOCK\s*UP)\s*DEAL.*$/i, '').replace(/\s+/g, ' ').trim(); }

  // ---- product data (inline JSON → normalized dollars) + live refresh ----
  function parse(txt) {
    try {
      return JSON.parse(txt).map(function (d) {
        return { h: d.h, t: cleanTitle(d.t), m: d.tg ? 'Top-Grain Leather' : 'Vegan Leather', v: d.v, p: d.p / 100, c: (d.c || 0) / 100,
          a: !!d.a, q: d.q, s: d.s, g: d.g, k: d.k, tg: !!d.tg, i: d.i };
      });
    } catch (e) { return []; }
  }
  var dataEl = root.querySelector('[data-sol-data]');
  var data = parse(dataEl ? dataEl.textContent : '[]');
  function refresh() {
    if (phase() !== 'live' || !root.dataset.sectionId) return;
    var u = new URL(location.href); u.searchParams.set('section_id', root.dataset.sectionId);
    fetch(u.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var m = html.match(/<script[^>]*data-sol-data[^>]*>([\s\S]*?)<\/script>/);
        var next = m ? parse(m[1]) : [];
        if (next.length) { data = next; root.dispatchEvent(new CustomEvent('sol:data', { detail: { data: data } })); }
      })
      .catch(function () {});
  }
  setInterval(refresh, 150000);
  // a sold-out signal from any module (add failed / .js says unavailable) → mark locally + tell everyone now
  function markGone(handle) {
    var hit = false;
    data.forEach(function (d) { if (d.h === handle && d.a) { d.a = false; hit = true; } });
    if (hit) root.dispatchEvent(new CustomEvent('sol:data', { detail: { data: data } }));
  }
  // cart lines from this sale (tier discount counts only these) — by handle, falls back to the "-stock-up-deal" suffix
  function isSale(handle) {
    if (/-stock-up-deal(-\d+)?$/.test(handle || '')) return true;
    for (var k = 0; k < data.length; k++) if (data[k].h === handle) return true;
    return false;
  }

  // ---- cart: Horizon module (window.SOLCart, opens drawer) → plain AJAX fallback ----
  function addToCart(variantId) {
    var items = [{ id: Number(variantId), quantity: 1 }];
    if (window.SOLCart) return window.SOLCart.add({ items: items });
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'Could not add to cart'); });
    }).then(function () { // full cart for the sticky bar (Afroyla review: add.js line payload has no item_count)
      return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    });
  }
  // flies into the floating cart bar (its thumbs) when it's on screen, else the header cart icon
  function flyToCart(src, fromEl) {
    if (!src || !fromEl || !fromEl.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var target = [].slice.call(document.querySelectorAll('[data-sol-bar]:not([hidden]) [data-sol-bar-thumbs], .header-actions__cart-icon, #cart-bubble')).filter(function (el) { return el.offsetParent !== null; })[0];
    if (!target) return;
    var a = fromEl.getBoundingClientRect(), b = target.getBoundingClientRect(), size = 64;
    var el = document.createElement('div');
    el.className = 'sol-fly';
    el.style.backgroundImage = 'url("' + src + '")';
    el.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    el.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    document.body.appendChild(el);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
    el.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px) scale(.7)', opacity: 1, offset: 0.5 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.15)', opacity: 0.4 }
    ], { duration: 650, easing: 'cubic-bezier(.4,0,.6,1)', fill: 'forwards' }).onfinish = function () { el.remove(); };
  }
  // Shared add feedback (anh 10-15): spinner + "Adding…" for at least MIN_BUSY ms (feels deliberate, bundles take
  // ~1–2 s anyway) → "Added ✓" → the bar paints (sol:added) → photo flies into the floating cart bar, which pops.
  // No cart drawer (horizon-cart module uses action 'update'). opts.keep = leave the "✓ In your cart" label (Lightning).
  var MIN_BUSY = 700;
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function runAdd(btn, item, opts) {
    opts = opts || {};
    if (btn.disabled) return Promise.resolve(false);
    var label = btn.textContent;
    btn.disabled = true; btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = '<span class="sol-spin" aria-hidden="true"></span>Adding…';
    return Promise.all([addToCart(item.v), wait(MIN_BUSY)]).then(function (res) {
      btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); btn.classList.add('is-added');
      btn.textContent = opts.addedText || 'Added ✓';
      root.dispatchEvent(new CustomEvent('sol:added', { detail: { cart: res[0], handle: item.h } }));
      requestAnimationFrame(function () { flyToCart(img(item.i, 300), btn); });
      if (!opts.keep) setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-added'); }, 1600);
      return true;
    }).catch(function (e) {
      btn.classList.remove('is-added', 'is-busy'); btn.removeAttribute('aria-busy');
      var gone = /sold out|not available|quantity|stock|availability/i.test(e.message);
      btn.textContent = gone ? 'Just sold out' : 'Try again';
      setTimeout(function () { btn.textContent = label; btn.disabled = false; if (gone) markGone(item.h); }, 1800);
      return false;
    });
  }

  // ---- end-of-sale countdown + "your time" label ----
  var cd = root.querySelector('[data-sol-countdown]');
  var local = root.querySelector('[data-sol-localtime]');
  if (local) {
    try { // only when the shopper's clock differs from ET, e.g. " (8:59 PM PDT your time)"
      var fmt = function (tz) { return new Date(END).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: tz }); };
      var mine = new Date(END).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZoneName: 'short' });
      if (fmt(undefined) !== fmt('America/New_York')) local.textContent = ' (' + mine + ' your time)';
    } catch (e) {}
  }
  // Live/ended blocks are toggled ONCE per phase change (not every second) so modules can hide their own blocks.
  function setEnded() {
    root.querySelectorAll('[data-sol-live]').forEach(function (el) { el.hidden = true; });
    var endEl = root.querySelector('[data-sol-ended]');
    if (endEl) endEl.hidden = false;
    root.classList.add('is-ended');
  }
  var wasEnded = phase() === 'ended';
  if (wasEnded) setEnded();
  function tickClock() {
    if (cd) cd.textContent = hms(END - now());
    if (!wasEnded && phase() === 'ended') { wasEnded = true; setEnded(); root.dispatchEvent(new CustomEvent('sol:ended')); }
  }
  tickClock();
  setInterval(tickClock, 1000);

  // jump buttons (hero + sticky bar) — Horizon swallows window.scrollTo / hash jumps, scrollIntoView works
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-sol-jump]');
    var t = a && root.querySelector(a.getAttribute('href'));
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Hero claims from LIVE prices (ops raised wallets $8.95/$9.95 → $11.95 at ~05:00 ET 10-15, max off 80% → 76%):
  // "Up to N% OFF" = real max over available pieces; "Bags from $X · Wallets from $Y" = real minimums.
  function heroFromData() {
    var av = data.filter(function (d) { return d.a; });
    if (!av.length) return;
    var maxOff = Math.max.apply(null, av.map(function (d) { return pct(d.p, d.c); }));
    var minOf = function (f) { var ps = av.filter(f).map(function (d) { return d.p; }); return ps.length ? Math.min.apply(null, ps) : 0; };
    var bag = minOf(function (d) { return d.g === 'bag' || d.g === 'small'; }), wal = minOf(function (d) { return d.g === 'wallet'; });
    var o = root.querySelector('[data-sol-offer]'), pr = root.querySelector('[data-sol-prices]'), wb = root.querySelector('[data-sol-wallet-with-bag]');
    if (o && maxOff) o.textContent = 'Up to ' + maxOff + '% OFF';
    if (wb && wal) wb.textContent = money(wal - 4); // "Add a wallet for $8.95 with any bag" = cheapest wallet − the $4 bag offer
    if (pr && (bag || wal)) pr.textContent = [bag ? 'Bags from ' + money(bag) : '', wal ? 'Wallets from ' + money(wal) : ''].filter(Boolean).join(' · ');
  }
  heroFromData();
  root.addEventListener('sol:data', heroFromData);

  // Deep links from email (#sol-lightning / #sol-shelf): Lightning + shelf are rendered by JS after load and Horizon
  // swallows hash jumps → re-scroll once the modules have painted (and once more after images/fonts settle).
  var hashT = /^#sol-(lightning|shelf)$/.test(location.hash) && root.querySelector(location.hash);
  if (hashT && phase() === 'live') {
    var jumpTo = function () { hashT.scrollIntoView({ block: 'start' }); };
    setTimeout(jumpTo, 400);
    window.addEventListener('load', function () { setTimeout(jumpTo, 150); }, { once: true });
  }

  window.SOL = {
    root: root, now: now, phase: phase, data: function () { return data; }, markGone: markGone, isSale: isSale,
    money: money, pct: pct, mss: mss, img: img, esc: esc, runAdd: runAdd
  };
})();
